import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";

class MProfile extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: 'intro',
		}
	}

	changeTab = (id) => {
		this.setState({
			activeTab: id
		})
	}

	render() {
		const record = this.props.record;

		// console.log(record)

		let eduCount = 0;
		// record.scholar_career.map((item, index) => {
		// 	if (item.career_type === 'edu')
		// 		eduCount++
		// })

		let careerCount = 0;
		// record.scholar_career.map((item, index) => {
		// 	if (item.career_type === 'career')
		// 		careerCount++;
		// })

		// const record = this.props.record;
		//
		return (
			<div className="tab-pane active">
				<div>
					<div className="research-area border-top-0">
						<div className="container">
							<div className="area-list">
								<div className="list-cell">
									<h3 className="detail-title">연구분야 키워드</h3>
									{record.research_keyword ?
										<div className="badge-group-inner">
											{record.research_keyword.map((item, index) => {
												return(<span key={index} className="badge badge outline-gray">{item.keyword}</span>)
											})}
										</div>
										: <div className="desc">입력된 정보가 없습니다.</div>}
								</div>
								<div className="list-cell">
									<h3 className="detail-title">상세 연구분야</h3>
									<div className="desc">{record.research_field ? record.research_field : '입력된 정보가 없습니다.'}</div>
								</div>
								<div className="list-cell">
									<h3 className="detail-title">희망 협업분야</h3>
									<div className="desc">{record.collabo_field ? record.collabo_field : '입력된 정보가 없습니다.'}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="mt-px-40">
					<div className="d-flex align-items-center mb-3">
						<button onClick={() => this.changeTab('intro')}
						        className={"btn-tab-nav mr-1 active-color-lightblue " + (this.state.activeTab === 'intro' ? 'active' : '')}>소개
						</button>
						<button onClick={() => this.changeTab('education')}
						        className={"btn-tab-nav mr-1 active-color-lightblue " + (this.state.activeTab === 'education' ? 'active' : '')}>학력
						</button>
						<button onClick={() => this.changeTab('career')}
						        className={"btn-tab-nav mr-1 active-color-lightblue " + (this.state.activeTab === 'career' ? 'active' : '')}>경력
						</button>
					</div>
					<div>
						{this.state.activeTab === 'intro' &&
						<div className="tab-data active">
							<div className="pt-4 pb-4 border-top border-bottom border-lightgray">
								<div className="font-size-14 color-lightblack">{record.intro ? record.intro : '입력된 정보가 없습니다.'}</div>
							</div>
						</div>
						}
						{this.state.activeTab === 'education' &&
						<div className="tab-data active">
							<div className="pt-4 pb-4 border-top border-bottom border-lightgray">
								{eduCount > 0 ?
									record.scholar_career.map((item, index) => {
										if (item.career_type === 'edu') {
											return (
												<div key={index} className="d-flex font-size-14 color-lightblack">
													<div className="flex-auto mr-2"><strong>{item.end_yyyymm}</strong></div>
													<div className="d-flex flex-1">{item.career_org}</div>
												</div>
											)
										}
									})
									:
									<div className="font-size-14 color-lightblack">해당 정보가 없습니다.</div>
								}
							</div>
						</div>
						}
						{this.state.activeTab === 'career' &&
						<div className="tab-data active">
							<div className="pt-4 pb-4 border-top border-bottom border-lightgray">
								{careerCount > 0 ?
									record.scholar_career.map((item, index) => {
										if (item.career_type === 'career') {
											return (
												<div key={index} className="d-flex font-size-14 color-lightblack">
													<div className="flex-auto mr-2"><strong>{item.end_yyyymm}</strong></div>
													<div className="d-flex flex-1">{item.career_org}</div>
												</div>
											)
										}
									})
									:
									<div className="font-size-14 color-lightblack">해당 정보가 없습니다.</div>
								}
							</div>
						</div>
						}
					</div>
				</div>
				{/*<div className="mt-65">*/}
				{/*	<div className="d-flex justify-content-between align-items-center mb-px-26">*/}
				{/*		<div className="d-flex align-items-center">*/}
				{/*			<h3 className="con-title">관심저자(논의)</h3>*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*	<div>*/}
				{/*		<div className="line-list-group">*/}
				{/*			<a href="#" className="researcher-list-item">*/}
				{/*				<div className="user-picture">*/}
				{/*					<div className="thumb">*/}
				{/*						<img src="../assets/images/user_picture.png" alt=""/>*/}
				{/*					</div>*/}
				{/*					<span className="icon icon-size-24 icon-user-favorite"/>*/}
				{/*				</div>*/}
				{/*				<div className="item-info">*/}
				{/*					<div className="item-info-inner">*/}
				{/*						<div className="item-name">강성철</div>*/}
				{/*						<div className="item-cate"><strong>교수</strong>사회과학대학·문헌정보학과*/}
				{/*						</div>*/}
				{/*						<div className="item-tag">환경정책론, 인사행정론, 개방거시경제학, 금융경제학</div>*/}
				{/*					</div>*/}
				{/*				</div>*/}
				{/*				<div className="item-value">발표논문 <strong*/}
				{/*					className="color-lightblue">20</strong></div>*/}
				{/*			</a>*/}
				{/*			<a href="#" className="researcher-list-item">*/}
				{/*				<div className="user-picture">*/}
				{/*					<div className="thumb">*/}
				{/*						<img src="../assets/images/user_picture.png" alt=""/>*/}
				{/*					</div>*/}
				{/*					<span className="icon icon-size-24 icon-user-favorite"/>*/}
				{/*				</div>*/}
				{/*				<div className="item-info">*/}
				{/*					<div className="item-info-inner">*/}
				{/*						<div className="item-name">강성철</div>*/}
				{/*						<div className="item-cate"><strong>교수</strong>사회과학대학·문헌정보학과*/}
				{/*						</div>*/}
				{/*						<div className="item-tag">환경정책론, 인사행정론, 개방거시경제학, 금융경제학</div>*/}
				{/*					</div>*/}
				{/*				</div>*/}
				{/*				<div className="item-value">발표논문 <strong*/}
				{/*					className="color-lightblue">20</strong></div>*/}
				{/*			</a>*/}
				{/*			<a href="#" className="researcher-list-item">*/}
				{/*				<div className="user-picture">*/}
				{/*					<div className="thumb">*/}
				{/*						<img src="../assets/images/user_picture.png" alt=""/></div>*/}
				{/*					<span className="icon icon-size-24 icon-user-favorite"/>*/}
				{/*				</div>*/}
				{/*				<div className="item-info">*/}
				{/*					<div className="item-info-inner">*/}
				{/*						<div className="item-name">강성철</div>*/}
				{/*						<div className="item-cate"><strong>교수</strong>사회과학대학·문헌정보학과*/}
				{/*						</div>*/}
				{/*						<div className="item-tag">환경정책론, 인사행정론, 개방거시경제학, 금융경제학</div>*/}
				{/*					</div>*/}
				{/*				</div>*/}
				{/*				<div className="item-value">발표논문 <strong*/}
				{/*					className="color-lightblue">20</strong></div>*/}
				{/*			</a>*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*</div>*/}
				{/*<div className="mt-65">*/}
				{/*	<div className="d-flex justify-content-between align-items-center mb-px-26">*/}
				{/*		<div className="d-flex align-items-center">*/}
				{/*			<h3 className="con-title">나의 검색조합(논의)</h3>*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*	<div>*/}
				{/*		<div className="accordion-wrap">*/}
				{/*			<div className="accordion-cell active">*/}
				{/*				<button type="" className="btn-accordion-item">Journal (3)</button>*/}
				{/*				<div className="collapse">*/}
				{/*					<div className="accordion-detail">*/}
				{/*						<div className="search-name-item">*/}
				{/*							<div className="item-name">이름이 길 경우는 이렇게 보입니다. 이름이 길 경우는 이렇게*/}
				{/*								보입니다. 이름이 길 경우는 이렇게 보입니다. 이름이 길 경우는 이렇게 보입니다. 이름이 길 경우는*/}
				{/*								이렇게 보입니다. 이름이 길 경우는 이렇게 보입니다. 이름이 길 경우는 이렇게 보입니다. 이름이 길*/}
				{/*								경우는 이렇게 보입니다.*/}
				{/*							</div>*/}
				{/*							<button type="button" className="btn-search-name-del">*/}
				{/*								<span className="icon icon-size-24 icon-trash-gray"/>*/}
				{/*							</button>*/}
				{/*						</div>*/}
				{/*						<div className="search-name-item">*/}
				{/*							<div className="item-name">내가 저장한 Journal 패싯검색 이름</div>*/}
				{/*							<button type="button" className="btn-search-name-del">*/}
				{/*								<span className="icon icon-size-24 icon-trash-gray"/>*/}
				{/*							</button>*/}
				{/*						</div>*/}
				{/*						<div className="search-name-item">*/}
				{/*							<div className="item-name">내가 저장한 Journal 패싯검색 이름</div>*/}
				{/*							<button type="button" className="btn-search-name-del">*/}
				{/*								<span className="icon icon-size-24 icon-trash-gray"/>*/}
				{/*							</button>*/}
				{/*						</div>*/}
				{/*					</div>*/}
				{/*				</div>*/}
				{/*			</div>*/}
				{/*			<div className="accordion-cell">*/}
				{/*				<button type="" className="btn-accordion-item">Journal (3)</button>*/}
				{/*				<div className="collapse">*/}
				{/*					<div className="accordion-detail">*/}
				{/*						<div className="search-name-item">*/}
				{/*							<div className="item-name">이름이 길 경우는 이렇게 보입니다. 이름이 길 경우는 이렇게*/}
				{/*								보입니다. 이름이 길 경우는 이렇게 보입니다. 이름이 길 경우는 이렇게 보입니다. 이름이 길 경우는*/}
				{/*								이렇게 보입니다. 이름이 길 경우는 이렇게 보입니다. 이름이 길 경우는 이렇게 보입니다. 이름이 길*/}
				{/*								경우는 이렇게 보입니다.*/}
				{/*							</div>*/}
				{/*							<button type="button" className="btn-search-name-del">*/}
				{/*								<span className="icon icon-size-24 icon-trash-gray"/>*/}
				{/*							</button>*/}
				{/*						</div>*/}
				{/*						<div className="search-name-item">*/}
				{/*							<div className="item-name">내가 저장한 Journal 패싯검색 이름</div>*/}
				{/*							<button type="button" className="btn-search-name-del">*/}
				{/*								<span className="icon icon-size-24 icon-trash-gray"/>*/}
				{/*							</button>*/}
				{/*						</div>*/}
				{/*						<div className="search-name-item">*/}
				{/*							<div className="item-name">내가 저장한 Journal 패싯검색 이름</div>*/}
				{/*							<button type="button" className="btn-search-name-del">*/}
				{/*								<span className="icon icon-size-24 icon-trash-gray"/>*/}
				{/*							</button>*/}
				{/*						</div>*/}
				{/*					</div>*/}
				{/*				</div>*/}
				{/*			</div>*/}
				{/*			<div className="accordion-cell">*/}
				{/*				<button type="" className="btn-accordion-item">내용이 길경우 이렇게 보여집니다. 내용이*/}
				{/*					길경우 이렇게 보여집니다. 내용이 길경우 이렇게 보여집니다. 내용이 길경우 이렇게 보여집니다. 내용이 길경우 이렇게*/}
				{/*					보여집니다. 내용이 길경우 이렇게 보여집니다. 내용이 길경우 이렇게 보여집니다. 내용이 길경우 이렇게 보여집니다. 내용이*/}
				{/*					길경우 이렇게 보여집니다. (3)*/}
				{/*				</button>*/}
				{/*				<div className="collapse">*/}
				{/*					<div className="accordion-detail">*/}
				{/*						<div className="search-name-item">*/}
				{/*							<div className="item-name">이름이 길 경우는 이렇게 보입니다. 이름이 길 경우는 이렇게*/}
				{/*								보입니다. 이름이 길 경우는 이렇게 보입니다. 이름이 길 경우는 이렇게 보입니다. 이름이 길 경우는*/}
				{/*								이렇게 보입니다. 이름이 길 경우는 이렇게 보입니다. 이름이 길 경우는 이렇게 보입니다. 이름이 길*/}
				{/*								경우는 이렇게 보입니다.*/}
				{/*							</div>*/}
				{/*							<button type="button" className="btn-search-name-del">*/}
				{/*								<span className="icon icon-size-24 icon-trash-gray"/>*/}
				{/*							</button>*/}
				{/*						</div>*/}
				{/*						<div className="search-name-item">*/}
				{/*							<div className="item-name">내가 저장한 Journal 패싯검색 이름</div>*/}
				{/*							<button type="button" className="btn-search-name-del">*/}
				{/*								<span className="icon icon-size-24 icon-trash-gray"/>*/}
				{/*							</button>*/}
				{/*						</div>*/}
				{/*						<div className="search-name-item">*/}
				{/*							<div className="item-name">내가 저장한 Journal 패싯검색 이름</div>*/}
				{/*							<button type="button" className="btn-search-name-del">*/}
				{/*								<span className="icon icon-size-24 icon-trash-gray"/>*/}
				{/*							</button>*/}
				{/*						</div>*/}
				{/*					</div>*/}
				{/*				</div>*/}
				{/*			</div>*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*</div>*/}
			</div>
		);
	}
};

export default MProfile;
